<template>
  <h3 class="h3">
    <img class="img" :src="icon" alt="" srcset="" />
    <slot>{{ title }}</slot>
  </h3>
</template>

<script>
export default {
  name: 'h3Title',
  props: {
    title: String,
    icon: String,
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';

.h3 {
  .flex_layout(row, flex-start);
  font-weight: 400;
  margin: 0;
  .img {
    margin-right: 0.3em;
    font-size: 18px;
    color: @font-color-black;
    width: 20px;
    height: 20px;
  }
}
</style>
